import { render } from "./BasketballMatchScoreBoard.vue?vue&type=template&id=c76511fc&scoped=true"
import script from "./BasketballMatchScoreBoard.vue?vue&type=script&lang=js"
export * from "./BasketballMatchScoreBoard.vue?vue&type=script&lang=js"

import "./BasketballMatchScoreBoard.vue?vue&type=style&index=0&id=c76511fc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c76511fc"]])

export default __exports__